import ListProcesses from "@/views/agro_exporter/quality_reports/container/ListProcesses.vue";
import ListContainers from "@/views/agro_exporter/quality_reports/container/ListContainers.vue";
import ListTemplates from "@/views/agro_exporter/quality_reports/container/ListTemplates.vue";
import ShowTemplateMainRep from "@/views/agro_exporter/quality_reports/container/ShowTemplateMainRep.vue"

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "quality_reports",
  permission: "container",
});


export default [
  {
    path: "/ae/:agro_exporter_id/quality_reports/container/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/container/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/container/list_containers/:agro_exporter_process_id",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/container/list_templates/:agro_exporter_process_id/:container_id",
    name: routeName("list_templates"),
    component: ListTemplates,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/quality_reports/container/:agro_exporter_process_id/:container_id/show_template_rep/:quality_template_main_rep_id",
    name: routeName("show_template_rep"),
    component: ShowTemplateMainRep,
    props: true,
    meta: META
  }
];
